/** Namespaces carregados na inicialização do i18next (bundle principal). */
export const EAGER_NAMESPACES = [
  "common",
  "app",
  "errors",
  "auth",
  "dataGrid",
  "profile",
  "settings_i18n",
  "themes",
  "shell",
  "notifications",
  "chatList",
  /** Uso amplo + useMemo que captura t() na 1ª render: lazy causava chaves na UI até reload. */
  "settings",
  "chat",
];

/** Namespaces carregados sob demanda (ver lazyNamespaces.js). */
export const LAZY_NAMESPACES = [
  "dashboard",
  "products",
  "chatbot",
  "onboarding",
];
